import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var SectionStack = function SectionStack(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("SiteHeaderSectionStack");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "children"
    })
  }, children));
};

SectionStack.displayName = "SiteHeader.SectionStack";
export default SectionStack;